import React, { lazy } from 'react';

export class RouteConstants {
  // Lazy load the PatientContainer component with a webpack chunk name "Patient"
  static UserOnBoarding = lazy(() => import(/* webpackChunkName: "UserOnBoarding" */ '../layout/OnboardContainer'));

  // Define module routes for the patients module
  static readonly MODULE_ROUTES = [
    {
      path: '/onboarding', // URL path for the patients list
      component: React.createElement(RouteConstants.UserOnBoarding), // Component to render for this route
      actionName: 'view', // Action name associated with this route
      displayName: 'Onboardning', // Display name for the route
      isMenu: false, // Indicates if this route should be shown in the menu
    },
  ];
}
